import { AxiosRequestSender } from '@vue-storefront/sdk-axios-request-sender';
import { client  } from '../client';

export async function unifiedCarts(token: string): Promise<[]> {
  return new AxiosRequestSender(client)
    .setUrl('unifiedCarts')
    .setMethod('POST')
    .setProps([{token: token}])
    .send();
}
